'use strict';

require('../../../i18n.js');
require('../shell/includes.js');
require('../../includes/companyData.js');
require('../../includes/graph.js');
require('../../includes/props.js');
require('./app.js');
require('./utils.js');
require('./mixins/userSettingsChanged.js');
require('./views/widget.js');
require('./views/panel.js');
require('./views/detailsLayout.js');
require('./views/titlebar.js');
require('./views/pdf/panel.js');
require('./views/png/panel.js');
require('./views/ppt/panel.js');
require('./views/widgets.js');
require('./views/curationWidgets.js');
require('./views/curationErrors.js');
require('./views/layout.js');
require('./views/multiSelectDropdown.js');
require('./views/pdf/layout.js');
require('./views/curationLayout.js');
require('./views/titlebar.js');
require('./views/wizard.js');
require('./views/exportDropdown.js');
require('./views/groupedSummaryItems.js');
require('./views/intervalDropdown.js');
require('./views/progressBar.js');
require('./views/reactLayouts.js');
require('./curations/filters/export.js');
require('./curations/filters/shell.js');
require('./curations/filters/channel.js');
require('./mixins/eventProxying.js');
require('./mixins/export.js');
require('./mixins/normalizeHeights.js');
require('./mixins/title.js');
require('./mixins/switchable.js');
require('./mixins/singleWidget.js');
require('./mixins/searchableLayout.js');
require('./models/configuration.js');
require('./models/curation.js');
require('./models/singleWidgetCuration.js');
require('./models/widget.js');
require('./models/reactCurationBridge.js');
require('./models/reactWidgetBridge.js');
require('./models/stateMachine.js');
require('./models/wizard.js');
require('./widgets/charts/chart.js');
require('./widgets/table.js');
require('./widgets/table/headerCell.js');
require('./widgets/table/tableMetricChooser.js');
require('./widgets/additionalAuthorization.js');
require('./widgets/chart.js');
require('./widgets/charts/stackedBar.js');
require('./widgets/charts/xy.js');
require('./widgets/charts/groupedBar.js');
require('./widgets/charts/line.js');
require('./widgets/charts/trendsLine.js');
require('./widgets/charts/pie.js');
require('./widgets/charts/companyPie.js');
require('./widgets/charts/distribution.js');
require('./widgets/table/columnPicker.js');
require('./widgets/deprecation.js');
require('./widgets/limitation.js');
require('./widgets/metricSummary.js');
require('./widgets/trendsTooltip.js');
require('./widgets/metric.js');
require('./widgets/companyMetricSummary.js');
require('./widgets/metricBreakout.js');
require('./widgets/metricPercentage.js');
require('./widgets/metricLegend.js');
require('./widgets/charts/glance.js');
require('./widgets/sectionHeader.js');
require('./router.js');
require('./controller.js');
require('./legacyRouteHandler.js');
